import { CANDIDATE_AVATAR_PLACEHOLDER } from './candidatePlaceholder';

/**
 * The grey silhouette in the avatar library, and what the API's
 * avatars:backfill-generic pinned every empty float/submission avatar to.
 */
export const GENERIC_AVATAR_SRC = '/avatars/generic/person.svg';

/**
 * Legacy gravatar URLs, which carried `d=mm` and so always resolved to
 * gravatar's own silhouette whether or not the address had a photo.
 *
 * Current URLs carry `d=404` and the API only stores one once it has confirmed
 * an image is there (App\Traits\ResolvesAvatarPlaceholders::gravatarUrlIfExists),
 * so those are real pictures. Keep this in step with the API.
 */
export function isLegacyGravatarUrl(src: string): boolean {
  return src.includes('gravatar.com') && src.includes('d=mm');
}

/**
 * Whether `src` is a stand-in rather than a picture of the candidate.
 *
 * Anonymising blurs an avatar to hide a likeness. There is no likeness in a
 * stand-in, so blurring one only turns it into a smudge — this is what the blur
 * is gated on.
 *
 * Matches the generic icon by path suffix, not equality: AvatarLibrary stores a
 * pick as an absolute same-origin URL, so what comes back is
 * `https://…/avatars/generic/person.svg`.
 */
export function isStandInAvatar(src?: string | null): boolean {
  if (!src) {
    return true;
  }

  if (src === CANDIDATE_AVATAR_PLACEHOLDER || isLegacyGravatarUrl(src)) {
    return true;
  }

  return src.split(/[?#]/)[0].endsWith(GENERIC_AVATAR_SRC);
}
